import LaunchTimeCache from "@/utils/log_event/launch_time_event/launchTimeCache";
import { sendEvent } from "@/utils/log_event";
import { LAUNCH_STEP_EXECUTION_TIME } from "@/utils/log_event/event_const";

export const launchEvent = () => {
  const launch_params = LaunchTimeCache.get();
  delete launch_params.before_init_launch_timestamp;
  sendEvent(LAUNCH_STEP_EXECUTION_TIME, launch_params);
};
